const edit = {
  fields: [
    {
      type: 'mixed',
      name: 'title_1',
      label: 'Mission Title',
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'image',
      name: 'image_1',
      label: 'Mission Image',
      required: true,
    },
    {
      type: 'mixed',
      name: 'text_1',
      label: 'Mission Body',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
    {
      type: 'mixed',
      name: 'title_2',
      label: 'Vision Title',
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
        },
      ],
    },
    {
      type: 'image',
      name: 'image_2',
      label: 'Vision Image',
      required: true,
    },
    {
      type: 'mixed',
      name: 'text_2',
      label: 'Vision Body',
      required: true,
      elements: [
        {
          type: 'text',
          name: 'en',
          label: 'English',
          rich: true,
        },
        {
          type: 'text',
          name: 'ar',
          label: 'Arabic',
          rich: true,
        },
      ],
    },
  ],
  main: true,
  breadcrumb: 'Mission & Vision',
  title: 'Mission & Vision',
};

const data = { edit };

export default data;
